// The computer players' names (owner 2026-10-26: "za każdym razem inna lista imion"): `hearts.names` in each language
// holds about 20 short first names, `Name` or `Name|From` (From: the form inside hearts.hint.received, "Karty od
// Ani"); a new game draws 3 of them with first letters unlike each other and unlike the player's own label (each
// first letter stands alone in a circle). Without the list (or too few names) the fixed hearts.bot.N are used.
// Pure: the texts come in through `tr` (the unit tests have no page for i18n).
type Tr = (key: string) => string;

export interface SeatNames {
  /** Index 1-3: the computer players (0 unused: the player's label is hearts.you). */
  readonly name: readonly string[];
  readonly from: readonly string[];
  /** Online: each seat's flag code ('' = a guest with none), null for a bot; unset offline (online/SeatAvatar.tsx). */
  readonly flags?: readonly (string | null)[];
  /** Online: seats a bot plays now (their player away or gone): no badge, "(bot)" after the name. */
  readonly benched?: readonly boolean[];
}

/** The first letter as the circle shows it (a whole character, also outside the Basic Multilingual Plane). */
export const initial = (name: string): string => (Array.from(name)[0] ?? '').toLocaleUpperCase();

export function fixedNames(tr: Tr): SeatNames {
  return { name: ['', tr('hearts.bot.1'), tr('hearts.bot.2'), tr('hearts.bot.3')], from: ['', tr('hearts.from.1'), tr('hearts.from.2'), tr('hearts.from.3')] };
}

/** The language's list: [name, from] pairs (a missing From is the name itself). */
export function nameList(raw: string): [string, string][] {
  if (!raw || raw === 'hearts.names') return [];
  return raw
    .split(';')
    .map((e) => e.trim())
    .filter(Boolean)
    .map((e) => {
      const [n, f] = e.split('|').map((x) => x.trim());
      return [n!, f || n!] as [string, string];
    });
}

/** 3 names drawn from `list`; null when the list has too few that fit (the caller takes the fixed ones). */
export function drawNames(rng: () => number, list: [string, string][], you: string): SeatNames | null {
  const used = new Set([initial(you)]);
  const pool = list.slice();
  const out: [string, string][] = [];
  while (out.length < 3 && pool.length) {
    const [entry] = pool.splice(Math.floor(rng() * pool.length), 1);
    if (used.has(initial(entry![0]))) continue;
    used.add(initial(entry![0]));
    out.push(entry!);
  }
  if (out.length < 3) return null;
  return { name: ['', ...out.map((e) => e[0])], from: ['', ...out.map((e) => e[1])] };
}
